var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 47,
    viewBox: "0 0 42 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171276839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171276869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1125 1.08503C17.136 0.121215 17.813 -0.257501 18.8466 0.182916C21.0655 1.12758 23.2695 2.10629 25.4777 3.07648C28.9524 4.60199 32.4271 6.12962 35.8996 7.66151C37.4992 8.36788 37.5654 9.08915 36.126 10.1125C31.0667 13.7103 26.0095 17.3124 20.9267 20.8804C20.5124 21.1719 19.7906 21.4506 19.4254 21.2783C19.058 21.106 18.8124 20.3826 18.7655 19.8762C18.2081 13.7912 17.6976 7.69981 17.1744 1.61268C17.1595 1.43609 17.1317 1.26162 17.1104 1.08716L17.1125 1.08503Z",
    fill: "#CE4A27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.655782 31.2653C-0.0788739 31.0334 -0.21769 30.4334 0.348251 29.7462C1.56556 28.2696 2.80422 26.808 4.03648 25.3442C5.97776 23.04 7.91905 20.7357 9.8646 18.4358C10.7616 17.3762 11.3275 17.4847 11.7931 18.8081C13.4268 23.4548 15.0649 28.1016 16.6708 32.7589C16.8011 33.1398 16.8545 33.7504 16.6431 33.9887C16.4295 34.2291 15.8209 34.2568 15.4215 34.1802C10.6334 33.2525 5.85389 32.2887 1.07223 31.3356C0.933409 31.3079 0.794598 31.2909 0.655782 31.2675V31.2653Z",
    fill: "#3282C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.0144 46.061C16.9039 46.0993 16.4255 45.3716 16.8676 44.1993C17.8158 41.6823 18.8025 39.1802 19.7784 36.6739C21.3161 32.7293 22.8537 28.7868 24.3978 24.8464C25.109 23.0316 25.9333 22.9103 27.2019 24.4379C31.6547 29.8059 36.1139 35.1675 40.5303 40.561C40.8913 41.0015 41.2564 41.7823 41.0835 42.1951C40.9083 42.6121 40.0904 42.9312 39.5138 43.0163C32.5516 44.0248 25.5831 44.9822 18.6167 45.9546C18.4159 45.9822 18.2152 46.0248 18.0165 46.0588H18.0144V46.061Z",
    fill: "#6AAA43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogo);
export default __webpack_public_path__ + "static/media/menu-logo.a4ad1a7873ba4b71660319e51ec95ec5.svg";
export { ForwardRef as ReactComponent };